// stars.js — Sternbewertung als Material-Symbole (gefüllt / halb / leer) statt ★-Zeichen.
// label: vorgelesener Text (z. B. „4 von 5“); ohne label ist die Reihe dekorativ (aria-hidden).
import { html, attrs } from '../core/h.js';

export function stars(rating, { label } = {}) {
  const r = Number(rating) || 0;
  return html`<span class="vc-stars" ${attrs(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': 'true' })}>${[1, 2, 3, 4, 5].map((i) =>
    html`<span class="vc-icon${r >= i - 0.25 ? ' is-on' : ''}" aria-hidden="true">${r >= i - 0.75 && r < i - 0.25 ? 'star_half' : 'star'}</span>`)}</span>`;
}

/** Ein einzelner gefüllter Stern vor einer Zahl (z. B. „★ 4,2“). */
export const starIcon = () => html`<span class="vc-icon vc-star" aria-hidden="true">star</span>`;
